<template>
  <ConfettiInput
    v-model="valueProxy"
    :type="passwordType"
    :label="label"
    :name="name"
    :is-disabled="isDisabled"
    :is-error="isError"
    :is-required="isRequired"
    :error-message="errorMessage"
    class="confetti-password-input"
    @input="$emit('input', valueProxy)"
  >
    <template #icon>
      <span
        v-if="!hideEyeIcon"
        class="confetti-input-icon confetti-input-icon-eye"
        :class="inputClass"
        @click="toggleType"
        @keyup.enter="toggleType"
      >
        <ConfettiIcon icon="eye-o" />
      </span>
      <span
        v-if="additionalIconType"
        class="confetti-input-icon"
        :class="additionalIconClass"
      >
        <ConfettiIcon :icon="additionalIconName" />
      </span>
    </template>
  </ConfettiInput>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import ConfettiIcon from "../ConfettiIcon";
import ConfettiInput from "./ConfettiInput";

const ALT_INPUT_TYPE = "text";
const INPUT_TYPE = "password";

export default {
  name: "ConfettiPasswordInput",
  components: {
    ConfettiIcon,
    ConfettiInput,
  },
  props: {
    additionalIconName: {
      type: String,
      default: null,
    },
    additionalIconType: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: INPUT_TYPE.replace(/^[a-z]?/u, (character) =>
        character.toUpperCase(),
      ),
    },
    value: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: INPUT_TYPE,
    },
    hideEyeIcon: {
      type: Boolean,
    },
    isDisabled: {
      type: Boolean,
    },
    isError: {
      type: Boolean,
    },
    isRequired: {
      type: Boolean,
    },
    errorMessage: {
      type: String,
      default: null,
    },
  },

  setup(props) {
    const passwordType = ref(INPUT_TYPE);
    const valueProxy = ref(props.value);

    function toggleType() {
      if (passwordType.value === INPUT_TYPE) {
        passwordType.value = ALT_INPUT_TYPE;
      } else {
        passwordType.value = INPUT_TYPE;
      }
    }

    const additionalIconClass = computed(
      () => `confetti-input-icon-${props.additionalIconType}`,
    );

    const inputClass = computed(() => `type-${passwordType.value}`);

    return {
      passwordType,
      valueProxy,
      toggleType,
      additionalIconClass,
      inputClass,
    };
  },
};
</script>
